import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateTerms, fetchTerms } from "../../../Redux/Slices/termsSlice";
import { useProperty } from "../../../PropertyContext";
import swal from "sweetalert";

export const EditTermsAndCondition = ({ termData }) => {

    const dispatch = useDispatch();
    const { selectedProperty } = useProperty();

    const [formData, setFormData] = useState({
        ID: "",
        Description: "",
        SortOrder: ""
    });

    const [loading, setLoading] = useState(false);

    // ✅ Prefill when modal opens
    useEffect(() => {
        if (termData) {
            setFormData({
                ID: termData.ID,
                Description: termData.Description,
                SortOrder: termData.SortOrder
            });
        }
    }, [termData]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const resultAction = await dispatch(updateTerms(formData));

            if (updateTerms.fulfilled.match(resultAction)) {

                // ✅ Fresh fetch
                await dispatch(fetchTerms(selectedProperty.PropertyID));

                swal("Success!", "Updated successfully!", "success");

                // close modal
                document.querySelector('#Edit-Terms-Condition .btn-close').click();

            } else {
                swal("Error!", "Update failed!", "error");
            }

        } catch (error) {
            swal("Error!", "Something went wrong!", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <textarea
                            rows={2}
                            name="Description"
                            value={formData.Description}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
